'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'face-glasses';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = ['M48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-22.3-3.5-43.8-10-64l-6 0 0 96 0 16-16 0-144 0-16 0 0-16 0-96-32 0 0 96 0 16-16 0L80 304l-16 0 0-16 0-96-6 0c-6.5 20.2-10 41.7-10 64zM80.7 144L224 144l16 0 0 16 32 0 0-16 16 0 143.3 0C394.3 86.3 329.6 48 256 48s-138.3 38.3-175.3 96zM124 349.3L164 322.7C176 340.8 211.9 368 256 368s80-27.2 92-45.3L388 349.3C368 379.2 317.9 416 256 416s-112-36.8-132-66.7z', 'M256 464C141.1 464 48 370.9 48 256c0-22.3 3.5-43.8 10-64l6 0 0 96 0 16 16 0 144 0 16 0 0-16 0-96 32 0 0 96 0 16 16 0 144 0 16 0 0-16 0-96 6 0c6.5 20.2 10 41.7 10 64c0 114.9-93.1 208-208 208zM256 0C148.6 0 56.6 66.2 18.6 160L16 160 0 160l0 32 8.1 0C2.8 212.5 0 233.9 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64l8.1 0 0-32-16 0-2.6 0C455.4 66.2 363.4 0 256 0zM240 160l0-16-16 0L80.7 144c37-57.7 101.7-96 175.3-96s138.3 38.3 175.3 96L288 144l-16 0 0 16-32 0zm16 256c61.9 0 112-36.8 132-66.7L348 322.7C336 340.8 300.1 368 256 368s-80-27.2-92-45.3L124 349.3c19.9 29.9 70 66.7 132 66.7zm48-144l0-96 112 0 0 96-112 0zM96 176l112 0 0 96L96 272l0-96zm96.4 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;